import type fetchBookingActions from '../../../../hosting-server/src/booking/functions/fetchBookingActions';
import { createServerQueryHook } from '../../core/hooks/serverHooksCreators';

const useBookingActions = createServerQueryHook<typeof fetchBookingActions>(
    'fetchBookingActions'
);

export default useBookingActions;
